import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'fin-author',
  templateUrl: './author.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AuthorComponent {
  author = input('');
}
